import React, { Component } from 'react';
import PropTypes from 'prop-types'
import {Grid, Paper, Typography} from '@material-ui/core'

class Player extends Component {
    render() {
        return (
            <Paper style={{padding:5}}>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <Typography variant="body1" inline style={{color:"#000000"}}>&spades;&nbsp;</Typography>
                        <Typography variant="body1" inline>{this.props.spades}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" inline style={{color:"#F44336"}}>&hearts;&nbsp;</Typography>
                        <Typography variant="body1" inline>{this.props.hearts}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" inline style={{color:"#F44336"}}>&diams;&nbsp;</Typography>
                        <Typography variant="body1" inline>{this.props.diamonds}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" inline style={{color:"#000000"}}>&clubs;&nbsp;</Typography>
                        <Typography variant="body1" inline>{this.props.clubs}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body1" noWrap color={"primary"} align={"center"}>{this.props.player}</Typography>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

Player.propTypes = {
    spades: PropTypes.string.isRequired,
    hearts: PropTypes.string,
    diamonds: PropTypes.string,
    clubs: PropTypes.string,
    player: PropTypes.string
}

export default Player;